import "core-js/modules/web.dom-collections.iterator.js";
import { runInAction } from "mobx";
import { useState } from "react";
import CommonStrata from "../../Models/Definition/CommonStrata";
import Input from "../../Styled/Input";
import { observer } from "mobx-react";
import { jsx as _jsx } from "react/jsx-runtime";
export const SelectableDimensionNumeric = observer(_ref => {
  var _dim$value;
  let {
    id,
    dim
  } = _ref;
  const [value, setValue] = useState((_dim$value = dim.value) === null || _dim$value === void 0 ? void 0 : _dim$value.toString());
  return /*#__PURE__*/_jsx(Input, {
    styledHeight: "34px",
    light: true,
    border: true,
    type: "number",
    name: id,
    value: value,
    min: dim.min,
    max: dim.max,
    invalidValue: Number.isNaN(parseFloat(value !== null && value !== void 0 ? value : "")),
    onChange: evt => {
      setValue(evt.target.value);
      const number = parseFloat(evt.target.value);
      if (!Number.isNaN(number)) {
        runInAction(() => dim.setDimensionValue(CommonStrata.user, number));
      }
    }
  });
});